
import React, { useState } from 'react'
// import { useSelector } from 'react-redux'
// import { Button, FormControl, FormGroup, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { FormControlLabel, Checkbox } from '@mui/material'
// import { TextField } from '@mui/material'

import './filterList.css'

export const ContactFilters = ({ searching, setSearching }) => {

    // const [anchorEl, setAnchorEl] = useState(null)
    const [form, setForm] = useState(searching?.filters)

    // const handleClick = (event) => {
    //     setAnchorEl(event.currentTarget);
    // }

    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    const handleChangeChecked = (event) => {
        setForm({
            ...form,
            [event.target.name]: event.target.checked
        });
    }

    const handleClean = () => {
        const initialData = searching.initial

        setSearching({
            ...searching,
            filters: initialData
        })

        setForm(initialData)
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        setSearching({
            ...searching,
            filters: {
                ...form,
                buscar: true
            }

        })

    }

    return (
        <div>
            <form onSubmit={handleSubmit} className="row g-2 formFilterList">

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_activo}
                                onChange={handleChangeChecked}
                                name="check_activo"
                                color='secondary'
                            />
                        }
                        label="Habilitados"
                    />
                </div>

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_desactivo}
                                onChange={handleChangeChecked}
                                name="check_desactivo"
                                color='secondary'
                            />
                        }
                        label="Desactivados"
                    />
                </div>

                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_empresas}
                                onChange={handleChangeChecked}
                                name="check_empresas"
                                color='secondary'
                            />
                        }
                        label="Empresas"
                    />
                </div>
                <div className="col-6 selectSpan">
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_personas}
                                onChange={handleChangeChecked}
                                name="check_personas"
                                color="secondary"
                            />
                        }
                        label="Personas"
                    />
                </div>
                <div className='col-6 selectSpan'>
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_clientes}
                                onChange={handleChangeChecked}
                                name="check_clientes"
                                color="secondary"
                            />}

                        label="Clientes"
                    />
                </div>
                <div className='col-6 selectSpan'>
                    <FormControlLabel
                        className='formControFilterList'
                        control={
                            <Checkbox
                                checked={form?.check_proveedores}
                                onChange={handleChangeChecked}
                                name="check_proveedores"
                                color="secondary"
                            />}

                        label="Proveedores"
                    />
                </div>
                <div className="col-12 formFilterListButtons">
                    <button
                        type="button" className="btn btn-light buttonLimpiarFiltro"
                        onClick={handleClean}
                    >
                        Limpiar filtros
                    </button>
                    <button
                        type="button" className="btn btn-primary buttonBuscar"
                        onClick={handleSubmit}>
                        Buscar
                    </button>
                </div>
            </form>
        </div>
    )
}
